module.exports = __webpack_public_path__ + "static/media/personal_pronoun_3rd_img.81ee97ad.JPG";